import script from "./MentorApplicationStatusModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MentorApplicationStatusModal.vue?vue&type=script&setup=true&lang=ts"

import "./MentorApplicationStatusModal.vue?vue&type=style&index=0&id=b593aa6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b593aa6a"]])

export default __exports__